import React from 'react';
import { Modal } from 'react-bootstrap';

const ViewFileModal = ({ show, handleClose, file }) => {
    const getFileUrl = () => {
        if (!file) return '';
        return URL.createObjectURL(file);
    };

    const getFileType = () => {
        if (!file) return '';
        return file.type.split('/')[0];
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            centered
            className="view-file-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>View File: {file?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
                {file && (
                    getFileType() === 'image' ? (
                        <img
                            src={getFileUrl()}
                            alt={file.name}
                            style={{ width: '100%', height: 'auto' }}
                        />
                    ) : (
                        <iframe
                            src={getFileUrl()}
                            style={{ width: '100%', height: '80vh' }}
                            title="Uploaded File"
                        />
                    )
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ViewFileModal; 